module.exports = __webpack_public_path__ + "static/Connected-Patient-Care1-ae7fdb86c7ebe9340dab4801c08b7a76.jpg";